import { useCallback, useState } from 'react';

type UseDialogHookResponse = [boolean, () => void, () => void] & {
  openDialog: boolean;
  handleOpenDialog: () => void;
  handleCloseDialog: () => void;
};

export const useDialog = () => {
  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = useCallback(() => {
    setOpenDialog(true);
  }, []);

  const handleCloseDialog = useCallback(() => {
    setOpenDialog(false);
  }, []);

  const result = [
    openDialog,
    handleOpenDialog,
    handleCloseDialog,
  ] as UseDialogHookResponse;

  result.openDialog = result[0];
  result.handleOpenDialog = result[1];
  result.handleCloseDialog = result[2];

  return result;
};
